/**
 * ProductSpecs Component
 * Product specifications table
 * BP-08-04: Marketplace Frontend (Family)
 */

import React, { useMemo } from 'react';
import type { ProductSpecsProps, ProductSpecification } from '@/features/marketplace/types/marketplaceTypes';

export const ProductSpecs: React.FC<ProductSpecsProps> = ({
  specifications,
  groupByCategory = true,
}) => {
  // Note: Backend no longer provides 'group' field, grouping removed
  const groupedSpecs = useMemo(() => {
    return { '': specifications };
  }, [specifications]);
  
  const groups = Object.entries(groupedSpecs);
  
  if (specifications.length === 0) {
    return (
      <div className="text-center py-8 text-warm-gray">
        No specifications available
      </div>
    );
  }
  
  return (
    <div className="space-y-6">
      {groups.map(([groupName, specs], groupIndex) => (
        <div key={groupName || groupIndex}>
          {groupName && groupByCategory && (
            <h4 className="
              font-display font-semibold text-navy
              mb-3 pb-2 border-b border-warm-gray/10
            ">
              {groupName}
            </h4>
          )}
          
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
            {specs.map((spec, index) => (
              <div
                key={`${spec.name}-${index}`}
                className="flex justify-between gap-4 py-2 border-b border-warm-gray/5"
              >
                <dt className="text-warm-gray font-medium text-sm">
                  {spec.name}
                </dt>
                <dd className="text-navy text-sm text-right">
                  {spec.value}{spec.unit ? ` ${spec.unit}` : ''}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      ))}
    </div>
  );
};

export default ProductSpecs;

